import { fromJS } from 'immutable';

import * as types from './constants';

const initState = fromJS({
  filters: {
    skip: 0,
    take: 10,
    page: 1,
    terms: '',
    isParticipating: true,
  },
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_FILTERS: {
      return state.set('filters', fromJS(payload));
    }
    case types.UPDATE_DIVIDEND_PAYOUTS_FILTERS: {
      return state.set('dividendPayoutsFilters', fromJS(payload));
    }
    default:
      return state;
  }
};
